import ABSSidePanel from '@abs/core/ABSSidePanel';
import { memo } from 'react';
import NavigationShortcuts from '../../shared-components/NavigationShortcuts';

function LeftSideLayout3() {
  return (
    <>
      <ABSSidePanel>
        <NavigationShortcuts className="py-16 px-8" variant="vertical" />
      </ABSSidePanel>
    </>
  );
}

export default memo(LeftSideLayout3);
